// extracted by mini-css-extract-plugin
module.exports = {"how-it-works":"HowItWorks_how-it-works__TZ78Y"};